import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import ButtonApp from "@/components/ButtonApp.vue";
import IconSvg from "@/components/IconSvg.vue";
import ItemAdv from "@/components/ItemAdv.vue";
import VideoMain from "@/components/VideoMain.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
    methods: {
        ...uiMapper.mapMutations(["openFormCall"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "activateFormField",
            "clearForm",
        ]),
    },
});
let ScreenAdv = class ScreenAdv extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.items = [
            { time: "10.00", text: "Сбор, общение, зарядка" },
            { time: "10.30", text: "Второй завтрак" },
            { time: "10.45", text: "Траектория дня" },
            {
                time: "11.00",
                text: "Тематический квест, конкурсы, опыты (активности на улице)",
            },
            {
                time: "12.20",
                text: "Интерактивная беседа &laquo;что делать если...&raquo;",
            },
            { time: "13.00", text: "Вкусный обед" },
            { time: "13.30", text: "Тихий час, время мыслить, чтение, настолки" },
            { time: "15.00", text: "Полезный полдник" },
            { time: "15.30", text: "Творчество, проекты" },
            { time: "16.30", text: "Активности на улице, танцы, челленджи, батлы" },
            { time: "17:30", text: "Свечка, свободные игры, личные проекты" },
            { time: "18:00", text: "Уход домой" },
        ];
    }
    get isGtMd() {
        return this.breakpoint === "lg" || this.breakpoint === "xl";
    }
    get isLtMd() {
        return this.breakpoint === "xs" || this.breakpoint === "sm";
    }
    get formCallMail() {
        return this.formMail("callback");
    }
    async onOpenFormClick() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle("Записаться на пробное занятие");
        this.setFormCallScreen("Экран Калейдоскоп событий");
        this.activateFormField(this.formCallMail);
        this.openFormCall();
    }
};
ScreenAdv = __decorate([
    Component({
        components: {
            ButtonApp,
            ItemAdv,
            IconSvg,
            VideoMain,
        },
    })
], ScreenAdv);
export default ScreenAdv;
